// ============================================================
// ERP Module Flow - Types & Config
// Data is loaded at runtime from /module-flow.json
// ============================================================

export type NodeStatus = 'done' | 'progress' | 'notstarted';

export type DomainKey = 'sales' | 'purchase' | 'finance' | 'inventory' | 'qc' | 'rd' | 'master';

export interface FlowNode {
  id: string;
  name: string;
  domain: DomainKey;
  layer: number;
  writeTables: string;
  readTables: string;
  status: NodeStatus;
  isHub?: boolean;
}

export interface FlowEdge {
  from: string;
  to: string;
  tables: string;
  strength: number;
  crossDomain: boolean;
}

export interface FlowData {
  nodes: FlowNode[];
  edges: FlowEdge[];
  routeMap: Record<string, string>;
}

export const DOMAIN_COLORS: Record<DomainKey, string> = {
  sales: '#4a9eff',
  purchase: '#b44aff',
  finance: '#2ecc71',
  inventory: '#f39c12',
  qc: '#e74c3c',
  rd: '#f1c40f',
  master: '#95a5a6',
};

export const DOMAIN_LABELS: Record<DomainKey, string> = {
  sales: '銷售 Sales (PWC)',
  purchase: '採購 Purchase (PWD)',
  finance: '財務 Finance (PWG/PWH)',
  inventory: '庫存 Inventory (PWM)',
  qc: '品檢/客訴 QC (PWN/PWP)',
  rd: '研發 R&D (PWJ)',
  master: '主檔 Master (PW1/PW9)',
};

export const ALL_DOMAINS: DomainKey[] = [
  'sales', 'purchase', 'finance', 'inventory', 'qc', 'rd', 'master',
];

/** Fetch flow data from /module-flow.json (in public folder, no rebuild needed) */
export async function loadFlowData(): Promise<FlowData> {
  const resp = await fetch('/module-flow.json');
  if (!resp.ok) throw new Error(`Failed to load module-flow.json: ${resp.status}`);
  const json = await resp.json();
  return {
    nodes: json.nodes as FlowNode[],
    edges: json.edges as FlowEdge[],
    routeMap: (json.routeMap || {}) as Record<string, string>,
  };
}
